import { connect } from 'react-redux';
import ModalConfirmForm from './ModalConfirmForm';
import { performFeaturesAction } from '../../../redux/actions';
import { newTicketscanSelector } from '../../../redux/selectors/featureActionsSelector';

const mapStateToProps = state => ({
  newTicketscanOptions: newTicketscanSelector(state),
});

const mapDispatchToProps = {
  onSubmit: performFeaturesAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalConfirmForm);



// WEBPACK FOOTER //
// ./src/js/common/components/ModalConfirmForm/FeaturesConfirmForm.js